<template>
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="22.069" height="22.069" rx="2" fill="#4F5359"/>
    <rect x="28.9656" width="22.069" height="22.069" rx="2" fill="#4F5359"/>
    <rect x="57.931" width="22.069" height="22.069" rx="2" fill="#4F5359"/>
    <rect y="28.9658" width="22.069" height="22.069" rx="2" fill="#4F5359"/>
    <rect y="57.9307" width="22.069" height="22.069" rx="2" fill="#4F5359"/>
    <rect x="28.9656" y="28.9658" width="22.069" height="22.069" rx="2" fill="#4F5359"/>
    <rect x="28.9656" y="57.9307" width="22.069" height="22.069" rx="2" fill="#4F5359"/>
    <rect x="57.931" y="28.9658" width="22.069" height="22.069" rx="2" fill="#4F5359"/>
    <rect x="57.931" y="57.9307" width="22.069" height="22.069" rx="2" fill="#4F5359"/>
  </svg>
</template>
